export default "__VITE_ASSET__DId4s1xa__"